import { useRef } from 'react';

import { Key } from './Key';
import { KeyComponentProps } from './types';
import { useKeyAnimation } from './useKeyAnimation';
import { useKeySound } from './useKeySound';

export function KeyWrapper({ letter, note, onKeyPlayed, ...rest }: KeyComponentProps) {
  const imageRef = useRef<HTMLImageElement>(null);
  const { offset, drawRipple } = useKeyAnimation(imageRef);
  const { playNote, stopNote } = useKeySound(letter, note, drawRipple, onKeyPlayed);

  return (
    <Key
      letter={letter}
      note={note}
      offset={offset}
      playNote={playNote}
      stopNote={stopNote}
      imageRef={imageRef}
      {...rest}
    />
  );
}
